import axios from 'axios';
import Qs from 'qs';

import Conf from './Conf';

const API_URL = Conf.apiBaseUri;

const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

export function logout() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function forceSessionLogout() {
  logout();
  axios.post(`${Conf.apiBaseUriLegacy}/user/logout`, Qs.stringify({}), {withCredentials: true}).then(res => {
    if (res.data.status === 'error') return;
    window.location.reload();
  });
}

export function login(email, password) {
  return axios
    .post(`${API_URL}/login_check`, {
      email,
      password,
    })
    .then(response => {
      if (response.data.token) {
        localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(response.data.token));
        localStorage.setItem(REFRESH_TOKEN_KEY, JSON.stringify(response.data.refresh_token));
      }

      return response.data;
    });
}

function getCurrentAccessToken() {
  return JSON.parse(localStorage.getItem(ACCESS_TOKEN_KEY));
}

export function authHeader() {
  const token = getCurrentAccessToken();

  if (token) {
    return {Authorization: `Bearer ${token}`};
  } else {
    return {};
  }
}

export const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 100000,
  headers: {
    ...authHeader(),
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config;
    if (!error.response) {
      return Promise.reject(error);
    }
    // Prevent infinite loops
    if (error.response.status === 401 && originalRequest.url === '/refresh_token') {
      forceSessionLogout();
      return Promise.reject(error);
    }

    // specific error handling done elsewhere
    if ((error.response.data.code !== 403 || error.response.status !== 403) && error.response.status !== 401) {
      return Promise.reject(error);
    }

    const refreshToken = JSON.parse(localStorage.getItem(REFRESH_TOKEN_KEY));
    if (!refreshToken) {
      forceSessionLogout();
      return;
    }

    // const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));
    // console.log('tokenParts', tokenParts);

    // // exp date in token is expressed in seconds, while now() returns milliseconds:
    // const now = Math.ceil(Date.now() / 1000);

    // if (tokenParts.exp <= now) {
    //   forceSessionLogout();
    //   return;
    // }

    return axios
      .post(`${API_URL}/refresh_token`, {
        refresh_token: refreshToken,
        grand_type: 'refresh_token',
      })
      .then(response => {
        localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(response.data.token));
        localStorage.setItem(REFRESH_TOKEN_KEY, JSON.stringify(response.data.refresh_token));

        const newHeaders = {
          ...axiosInstance.defaults.headers,
          ...authHeader(),
        };
        axiosInstance.defaults.headers = newHeaders;
        originalRequest.headers = newHeaders;

        return axiosInstance(originalRequest);
      })
      .catch(err => {
        if (err.response.status === 401 || err.response.status === 403) {
          forceSessionLogout();
          return Promise.reject(err);
        }
      });
  },
);
